import { render, staticRenderFns } from "./CompanyLetterTemplate.vue?vue&type=template&id=1d796ee9&scoped=true"
import script from "./CompanyLetterTemplate.vue?vue&type=script&lang=js"
export * from "./CompanyLetterTemplate.vue?vue&type=script&lang=js"
import style0 from "./CompanyLetterTemplate.vue?vue&type=style&index=0&id=1d796ee9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d796ee9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d796ee9')) {
      api.createRecord('1d796ee9', component.options)
    } else {
      api.reload('1d796ee9', component.options)
    }
    module.hot.accept("./CompanyLetterTemplate.vue?vue&type=template&id=1d796ee9&scoped=true", function () {
      api.rerender('1d796ee9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CompanyLetterTemplate.vue"
export default component.exports